<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>
							<div
								class="modal-header row"
								style="justify-content: flex-end;"
							>
								<!-- <div class="col-6">
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                </div> -->
								<div class="col">
									<button
										type="button"
										class="close"
										@click="$emit('closeModal')"
									>
										<span aria-hidden="true">&times;</span>
									</button>
								</div>
							</div>

							<div class="modal-body">
								<h2 class="title">Tambah Sparepart</h2>
								<form>
									<div class="row row-space">
										<div
											class="col-12"
											style="padding: 20px;width:50%"
										>
											<div class="row">
												<div class="col">
													<label
														class="label text-left pl-3"
														>Tipe Sparepart<span
															style="color: red;"
															>*</span
														></label
													>
												</div>
											</div>
											<div
												class="row"
												style="padding-top:6px;"
											>
												<div
													class="col"
													style="padding-right:0"
												>
													<button
														style="border-radius : 6px 0px 0px 6px"
														type="button"
														class="w-100 btn"
														:class="
															form.sparepart_type ==
															'J'
																? 'btn-primary'
																: 'btn-outline-primary'
														"
														@click="
															form.sparepart_type =
																'J'
														"
													>
														Jasa
													</button>
												</div>
												<div
													class="col"
													style="padding-left:0"
												>
													<button
														style="border-radius : 0px 6px 6px 0px"
														type="button"
														class="w-100 btn"
														:class="
															form.sparepart_type ==
															'P'
																? 'btn-primary'
																: 'btn-outline-primary'
														"
														@click="
															form.sparepart_type =
																'P'
														"
													>
														Part
													</button>
												</div>
											</div>
										</div>
										<div
											:class="{'col-xs-12 col-sm-12 col-md-6 col-lg-6' : form.sparepart_type == 'J' , 'col-12' : form.sparepart_type == 'P'}"
										>
											<div class="input-group">
												<label class="label"
													>Sparepart<span
														style="color: red;"
														>*</span
													></label
												>
												<!-- <MultiSelect
                          v-model="selected.sparepart"
                          :options="options['sparepart'+form.sparepart_type].map(x => x.id)"
-label="opt => options.['sparepart'+form.sparepart_type].find(x => x.id == opt)[form.sparepart_type=='J'?'name':'sparepart_variants.name']"
                          placeholder="Pilih Sparepart"
                        ></MultiSelect> -->

												<MultiSelect
													v-if="
														options.sparepartVariants
													"
													v-model="selected.sparepart"
													:options="
														options.sparepartVariants
													"
													track-by="id"
													label="alias"
													placeholder="Pilih Sparepart"
												></MultiSelect>
											</div>
										</div>
										<div
											class="col-xs-12 col-sm-12 col-md-6 col-lg-6"
											v-if="form.sparepart_type == 'J'"
										>
											<div class="input-group">
												<label class="label"
													>Extension<span
														style="color: red;"
														>*</span
													></label
												>

												<MultiSelect
													:disabled="
														!selected.sparepart
													"
													v-model="form.extension"
													:options="extensionList"
													track-by="id"
													placeholder="Pilih Sparepart"
												></MultiSelect>
											</div>
										</div>
										<!-- <div
											class="col-xs-12 col-sm-6 col-md-6 col-lg-6"
											v-else
										>
											<div class="input-group">
												<label class="label"
													>Inden<span
														style="color: red;"
														>*</span
													></label
												>
												<input
													class="input--style-4"
													type="number"
													name="quantity"
													:disabled="
														form.sparepart_type ==
															'J'
													"
													v-model="
														form.supplier_prices[0]
															.inden
													"
													placeholder="Ketik Inden Hari"
												/>
											</div>
										</div> -->
									</div>

									<div class="row row-space">
										<!-- <div
											class="col-xs-12 col-sm-6 col-md-6 col-lg-6"
										>
											<div class="input-group">
												<label class="label"
													>Supplier<span
														style="color: red;"
														>*</span
													></label
												>
												<MultiSelect
													v-model="
														form.supplier_prices[0]
															.supplier_id
													"
													:options="
														options.supplier.map(
															(x) => x.id
														)
													"
													:custom-label="
														(opt) =>
															options.supplier.find(
																(x) =>
																	x.id == opt
															).name
													"
													:disabled="
														form.sparepart_type ==
															'J'
													"
													placeholder="Pilih Supplier"
												></MultiSelect>
											</div>
										</div> -->

										<div
											class="col-xs-12 col-sm-6 col-md-6 col-lg-6"
										>
											<div class="input-group">
												<label class="label"
													>Jumlah<span
														style="color: red;"
														>*</span
													></label
												>
												<input
													class="input--style-4"
													type="number"
													name="quantity"
													:disabled="form.sparepart_type == 'J'"
													v-model="form.quantity"
													placeholder="Ketik Jumlah"
												/>
											</div>
										</div>
										<div
											class="col-xs-12 col-sm-6 col-md-6 col-lg-6"
										>
											<div class="input-group">
												<label class="label"
													>Tipe Jasa<span
														style="color: red;"
														>*</span
													></label
												>
												<MultiSelect
													:disabled="
														form.sparepart_type ==
															'P'
													"
													class="mt-1"
													:options="[
														'G/C',
														'R/C',
														'Special Repair',
													]"
													placeholder="Pilih Tipe Jasa"
													v-model="form.type"
													:maxHeight="200"
												/>
											</div>
										</div>
										
									</div>
									<div class="row row-space">
										<div class="col-md-12">
											<div class="input-group">
												<label class="label"
													>Sparepart Description<span
														style="color: red;"
														>*</span
													></label
												>
												<input
													class="input--style-4"
													type="text"
													name="price"
													v-model="form.part_number"
													placeholder="Ketik Deskripsi Sparepart"
												/>
											</div>
											<div class="row mt-2">
												<div
													class="col-4"
													v-for="description in descriptionList"
												>
													<button
														class="btn btn-secondary"
														type="button"
														@click="
															updateDescription(
																description
															)
														"
													>
														{{ description }}
													</button>
												</div>
											</div>
										</div>
									</div>
									<div class="row row-space" v-if="form.sparepart_type == 'J'">
										<div class="col-md-6 offset-md-3">
											<div class="input-group">
												<label class="label"
													>Harga<span
														style="color: red;"
														>*</span
													></label
												>
												<input
													class="input--style-4"
													type="text"
													name="price"
													v-model="
														form.supplier_prices[0]
															.price_per_item
													"
													placeholder="Ketik Harga"
												/>
												<div
													style="display: flex; width:100%; padding:0 20px"
													class="row mt-2"
												>
													<input
														type="checkbox"
														class="col-1"
														id="ppn_included"
														v-model="
															form
																.supplier_prices[0]
																.without_ppn
														"
													/>
													<label
														class="col-11"
														for="ppn_included"
														>Harga Tanpa PPN</label
													>
												</div> 
												<div
													style="display: flex; width:100%; padding:0 20px"
													class="row mt-2"
												>
													<input
														type="checkbox"
														class="col-1"
														:disabled="
															form
																.supplier_prices[0]
																.without_ppn
														"
														id="ppn_included"
														v-model="
															form
																.supplier_prices[0]
																.ppn_included
														"
													/>
													<label
														class="col-11"
														for="ppn_included"
														>Harga Termasuk
														PPN</label
													>
												</div>
											</div> 
										</div> 
									</div>
									<div class="row row-space" v-else>
										<div class="col-md-6 offset-md-3">
											<div class="input-group">
												<label class="label"
													>Harga<span
														style="color: red;"
														>*</span
													></label
												>
												<input
													class="input--style-4"
													type="text"
													name="price"
													v-model="
														form.estimated_price
													"
													placeholder="Ketik Harga"
												/>
												
											</div> 
										</div> 
									</div>
									<div class="row">
										<div
											class="col mt-5"
											style="text-align: center"
										>
											<button
												type="button"
												class="btn btn-outline-danger"
												style="font-size:140%"
												@click="$emit('closeModal')"
											>
												Kembali
											</button>
											<button
												type="button"
												class="btn btn-primary ml-5"
												style="font-size:150%"
												@click="submitForm()"
												:disabled="disableContinue"
											>
												Tambah
											</button>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>
				<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
			</div>
		</div>
	</transition>
</template>

<script>
import MultiSelect from "vue-multiselect";

export default {
	data() {
		return {
			options: {
				sparepart: [],
				supplier: this.$store.getters.getSupplier,
				sparepartVariants: this.$store.getters
					.getSparepartVariant("J")
					.filter((x) => x.is_show),
			},
			rangeConfig: {
				altInput: true,
				altInputClass: "form-control input flatpickr-input w-100",
				animate: !this.isRTL(),
			},
			selected: {
				sparepart_type: "J",
				sparepart: null,
				sparepartSide: null,
			},
			form: {
				sparepart_type: "J",
				sparepart_name: null,
				sparepart_id: null,
				part_number: "",
				quantity: "",
				type: "",
				extension: "",
				estimated_price : 0,
				supplier_prices: [
					{
						supplier_id: 6,
						ppn_included: false,
						price_per_item: "",
						without_ppn: false,
						inden: 0,
					},
				],
			},
			disableContinue: false,
		};
	},
	props: ["brand_id"],
	components: {
		MultiSelect,
	},
	mounted() {},
	computed: {
		getPrice: function() {
			return this.form.supplier_prices[0].price_per_item;
		},
		extensionList: function() {
			if (this.selected.sparepart) {
				let listOfExtension = this.options.sparepartVariants.find(
					(x) => x.id == this.selected.sparepart.id
				).extension;
				if (listOfExtension != null) {
					listOfExtension = listOfExtension.split(",");
				}

				return listOfExtension ? listOfExtension : [];
			} else {
				return ["No Extension Available"];
			}
		},
		descriptionList: function() {
			if (this.selected.sparepartt) {
				let listOfDescription = this.sparepartMaster[
					this.sparepart_type
				].find((x) => x.id == this.selected.sparepart.id).description;
				if (listOfDescription != null) {
					listOfDescription = listOfDescription.split(",");
				}

				return listOfDescription ? listOfDescription : [];
			} else {
				return [];
			}
		},
	},
	watch: {
		getPrice: function() {
			const result = this.form.supplier_prices[0].price_per_item
				.replace(/\D/g, "")
				.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(
				() => (this.form.supplier_prices[0].price_per_item = result)
			);
		},
		"form.estimated_price": function() {
			const result = this.form.estimated_price
				.replace(/\D/g, "")
				.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
			this.$nextTick(
				() => (this.form.estimated_price = result)
			);
		},
		"form.sparepart_type": {
			handler() {
				this.selected.sparepart = null;

				this.form.supplier_prices[0].supplier_id =
					this.form.sparepart_type == "J" ? 6 : null;
				this.form.type =
					this.form.sparepart_type == "J" ? this.form.type : null;
				this.form.supplier_prices[0].inden =
					this.form.sparepart_type == "J"
						? this.form.supplier_prices[0].inden
						: 0;

				if(this.form.sparepart_type == 'J')
					this.form.quantity = 1

				// this.options.sparepart = this.$store.getters.getSparepart(this.brand_id, this.form.sparepart_type);
				this.options.sparepartVariants = this.$store.getters
					.getSparepartVariant(this.form.sparepart_type)
					.filter((x) => x.is_show);
			},
			immediate: true,
		},
		"selected.sparepart": {
			async handler() {
				if (
					this.selected.sparepart == null ||
					this.selected.sparepart == ""
				) {
					this.form.sparepart_id = null;
					this.form.sparepart_name = null;
				} else {
					let sp = await this.getCorrectSparepartId(
						this.selected.sparepart.id
					);
					this.form.sparepart_id = sp[0].id;
					this.form.sparepart_name = this.selected.sparepart.name;
				}
			},
		},
	},
	methods: {
		updateDescription(text) {
			this.$set(this.form, "part_number", text);
		},
		validateForm() {
			var valid = true;
			var error = [];
			// if(this.form.sparepart_side == '' || this.form.sparepart_side == null){//Sparepart Side [Required]
			//   valid = false;
			//   error.push('Sisi Suku Cadang wajib terisi');
			// }

			if (
				this.form.sparepart_id == "" ||
				this.form.sparepart_id == null
			) {
				//Sparepart ID [Required]
				valid = false;
				error.push("Sparepart wajib terisi");
			}

		

			// if (
			// 	this.form.supplier_prices[0].supplier_id == "" ||
			// 	this.form.supplier_prices[0].supplier_id == null
			// ) {
			// 	//Supplier ID [Required]
			// 	valid = false;
			// 	error.push("Supplier wajib terisi");
			// }

			if (this.form.quantity == "" || this.form.quantity == null) {
				//Quantity [Required]
				valid = false;
				error.push("Jumlah wajib terisi");
			} else if (isNaN(this.form.quantity)) {
				valid = false;
				error.push("Jumlah hanya dapat diisi dengan nomor");
			} else if (this.form.quantity <= 0) {
				valid = false;
				error.push("Jumlah harus terisi minimal 1 buah");
			}

			if (this.form.sparepart_type == "P") {
				// if (
				// 	this.form.supplier_prices[0].inden == "" ||
				// 	this.form.supplier_prices[0].inden == null
				// ) {
				// 	//Quantity [Required]
				// 	valid = false;
				// 	error.push("Inden wajib terisi");
				// } else if (isNaN(this.form.supplier_prices[0].inden)) {
				// 	valid = false;
				// 	error.push("Inden hanya dapat diisi dengan nomor");
				// } else if (this.form.supplier_prices[0].inden <= 0) {
				// 	valid = false;
				// 	error.push("Inden harus terisi minimal 1 hari");
				// }
				if (
					this.form.estimated_price == "" ||
					this.form.estimated_price == null
				) {
					//Price [Required]
					valid = false;
					error.push("Harga wajib terisi");
				}

			} else if (this.form.sparepart_type == "J") {
				if (this.form.type == "" || this.form.type == null) {
					//Supplier ID [Required]
					valid = false;
					error.push("Tipe Jasa wajib terisi");
				}

				if (
					this.form.supplier_prices[0].price_per_item == "" ||
					this.form.supplier_prices[0].price_per_item == null
				) {
					//Price [Required]
					valid = false;
					error.push("Harga wajib terisi");
				}
			}

			

			if (!valid) this.$store.dispatch("triggerAlert", [false, error]);
			else return valid;
		},
		async submitForm() {
			let vm = this;

			let form = JSON.parse(JSON.stringify(this.form))
			if (vm.validateForm()) {

				if(form.sparepart_type == 'J'){
					form.supplier_prices[0].price_per_item = parseInt(
						form.supplier_prices[0].price_per_item
							.split(",")
							.join("")
					);
					delete form.estimated_price
				}
					
				else {
					form.estimated_price = parseInt(
						form.estimated_price
							.split(",")
							.join("")
					)
					delete form.supplier_prices
				}

				if(!form.extension) delete form.extension

				// this.form.estimated_price = this.form.supplier_prices[0].price_per_item
				this.$emit("addSparepart", form);
			}
		},
		async getCorrectSparepartId(id) {
			let data;
			this.disableContinue = true;

			let url = `/api/v1/masterData/sparepart?variant_id=${id}`;

			if (this.form.sparepart_type == "P")
				url += `&brand_id=${this.brand_id}`;

			await this.$http
				.get(url)
				.then((resp) => {
					data = resp.data.data;
					this.disableContinue = false;
				})
				.catch((err) => {
					console.log(err);
				});
			return data;
		},
	},
};
</script>

<style scoped>
/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
	outline: none;
	margin: 0;
	border: none;
	-webkit-box-shadow: none;
	-moz-box-shadow: none;
	box-shadow: none;
	width: 100%;
	font-size: 14px;
	font-family: inherit;
}

.input--style-4 {
	line-height: 50px;
	background: #fafafa;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-webkit-border-radius: 5px;
	-moz-border-radius: 5px;
	border-radius: 5px;
	padding: 0 20px;
	font-size: 16px;
	color: #666;
	-webkit-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
	/* WebKit, Blink, Edge */
	color: #666;
}

.input--style-4:-moz-placeholder {
	/* Mozilla Firefox 4 to 18 */
	color: #666;
	opacity: 1;
}

.input--style-4::-moz-placeholder {
	/* Mozilla Firefox 19+ */
	color: #666;
	opacity: 1;
}

.input--style-4:-ms-input-placeholder {
	/* Internet Explorer 10-11 */
	color: #666;
}

.input--style-4:-ms-input-placeholder {
	/* Microsoft Edge */
	color: #666;
}

.label {
	font-size: 16px;
	color: #555;
	text-transform: capitalize;
	display: block;
	margin-bottom: 5px;
}

.radio-container {
	display: inline-block;
	position: relative;
	padding-left: 30px;
	cursor: pointer;
	font-size: 16px;
	color: #666;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.radio-container input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
	background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
	display: block;
}

.radio-container .checkmark:after {
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	-o-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	width: 12px;
	height: 12px;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	background: #57b846;
}

.checkmark {
	position: absolute;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #e5e5e5;
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50%;
	-webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	-moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
	box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
	content: "";
	position: absolute;
	display: none;
}

.input-group {
	position: relative;
	/* margin-bottom: 22px; */
	padding: 20px;
}

.input-group-icon {
	position: relative;
}

.input-icon {
	position: absolute;
	font-size: 18px;
	color: #999;
	right: 18px;
	top: 50%;
	-webkit-transform: translateY(-50%);
	-moz-transform: translateY(-50%);
	-ms-transform: translateY(-50%);
	-o-transform: translateY(-50%);
	transform: translateY(-50%);
	cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
	font-size: 40px;
	color: #525252;
	margin-bottom: 40px;
	text-align: center;
}
</style>
